import { useState, useEffect, useRef } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { Tooltip } from "antd";

//Props Validations
import PropTypes from "prop-types";

//Material UI Components
import { useTheme } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import ListItemIcon from "@mui/material/ListItemIcon";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

//Material UI Icons
import HomeIcon from "@mui/icons-material/Home";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SettingsIcon from "@mui/icons-material/Settings";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import HelpIcon from "@mui/icons-material/Help";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

// import Assets
import uniLogoWithName from "../../assets/consumer_cloud.png";
import forwardPng from "../../assets/forward.png";
import excelIcon from "../../assets/excel-icon.png";
import auditingVariableDocumentsIcon from "../../assets/icons/auditingVariableDocuments.png";
import productDownlodIcon from "../../assets/icons/product info.png";
import autoDeckReportPng from "../../assets/auto-deck-report.png";

import DownloadDialog from "./DownloadDialog";
import AuditingVariablesDocumentDialog from "../dataControlPanel/centralizedDataMapping/AuditingVariablesDocumentDialog";
//import helper
import { consumerFilterPayload } from "../../utils/consumerFilterUtils";

import { useSelector, useDispatch } from "react-redux";
import { loadProductListState } from "store/features/respondentDashboardSlice";
import { loadSelectedProductState } from "../../store/features/autoDeckReportSlice"

const disableMenuItem = {
    cursor: "not-allowed",
};

function Header({ title = "", titleSuffix = null, isStudySelected = false }) {
    const theme = useTheme();

    const dispatch = useDispatch();
    const consumerFilterStoreData = useSelector((state) => state.consumerFilterStore.currentSelectedFilters);
    const consumerFilterStoreDataForCorrelation = useSelector((state) => state.correlationStore.currentSelectedFiltersForCorrelation);
    const role = useSelector((state) => state.userStore.role) || null;
    const userAdmin = useSelector((state) => state.userStore.userAdmin) || false;
    const studyData = useSelector((state) => state.studyDataStore.selectedStudies);
    const selectedProducts = useSelector((state) => state.matchNetStore.selectedProducts);
    const listedStudiesData = useSelector((state) => state.studyDataStore.listedStudies);
    const coreDataIds = studyData.map((ele) => ele.id).join(",");
    const coreDataIdsForExportStudies = studyData.length ? studyData.map((ele) => ele.id).join(",") : listedStudiesData.map((ele) => ele.id).join(",");
    const filterSelected = useSelector((state) => state.consumerFilterStore.filterSelectionStatus);
    const correlationFilterSelected = useSelector((state) => state.correlationStore.filterSelectionStatus);
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const productsTestCodeMapData = useSelector((state) => state.studyDataStore.productTestCodeMap);
    const isDataMappingAcrossStudies = useSelector((state) => state.dataControlStore.isDataMappingAcrossStudies);
    const centralizedDataMappingSelectedStudyType = useSelector((state) => state.dataControlStore.centralizedDataMappingSelectedStudyType);
    const centralizedDataMappingSelectedStudyTypeMethod = useSelector((state) => state.dataControlStore.centralizedDataMappingSelectedStudyTypeMethod);
    const respondentSettingsStudyType = useSelector((state) => state.settingsStore.respondentSettingsStudyType);
    const respondentSettingsStudyTypeMethod = useSelector((state) => state.settingsStore.respondentSettingsStudyTypeMethod);
    // const selectedStudyType = useSelector((state) => state.matchNetStore.selectedStudyType);
    const textThemeSelections = useSelector((state) => state.textThemeStore.selections);
    const textThemeAppliedConsumerFilters = useSelector((state) => state.textThemeStore.appliedConsumerFilters);
    const selectedProduct = useSelector((state) => state.autoDeckReportStore.selectedProduct);
    const selectedTabForAutoDeck = useSelector((state) => state.autoDeckReportStore.selectedTab);
    // tTestPerformed = false, confidenceInterval = "", tTestType = "", tTestProducts = "", tTestCoreDataId = 0, checkedDataTypeForTest = "", tTestAnalysisType = "",
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const [openDownloadDialog, setOpenDownloadDialog] = useState(false);
    const [openAuditingVariablesDocumentDialog, setOpenAuditingVariablesDocumentDialog] = useState(false);
    const [respondentDialogueOpen, setRespondentDialogueOpen] = useState(false);
    const [checkedProduct, setCheckedProduct] = useState([]);
    const [disableMoveIcon, setDisableMoveIcon] = useState(true);
    const [isExcelDownloadable, setIsExcelDownloadable] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const disableProductInfoAndExportStudiesBtns = title.toLowerCase() === "data control panel" || title.toLowerCase() === "user management" || title.toLowerCase() === "match net" || title.toLowerCase() === "matchnet lookup table" || title.toLowerCase() === "matchnet - cross study comparison" || (title === "AutoDeck Report" && selectedTabForAutoDeck === "generation" && role !== "admin");
    const [disableStatus, setDisableStatus] = useState(false);
    const isDataControlPanelPage = window.location.pathname.includes("/data-control-panel");

    const isClaimsMappingPage = window.location.pathname.includes("/claims-mapping");
    const isRespondentSettingsPage = window.location.pathname.includes("/respondent-settings");

    // Fragrance Driver page
    const isFragranceDriverPage = window.location.pathname.includes("/fragrance-driver");

    const isCentralizedDataMappingPage = window.location.pathname.includes("/centralized-data-mapping");

    // Condition to hide Excel Export button (hide for all Data Control Panel tabs except Claims Mapping)
    const isMatchNetPage = title.toLowerCase() === "match net";
    const [hideExcelExport, setHideExcelExport] = useState(false);
    // const hideExcelExport = (isDataControlPanelPage && !isClaimsMappingPage && !isRespondentSettingsPage) || isMatchNetPage;

    // Condition to hide Export Studies button (hide for all Data Control Panel tabs)
    const hideExportStudies = isDataControlPanelPage;
    const disableExcelExportOnRespondentSettings = isRespondentSettingsPage && (!respondentSettingsStudyType || !respondentSettingsStudyTypeMethod);

    // Condition to hide the auto deck report button
    const showAutoDeckReport = title === "Studies" || title === "Overall KPI Analysis" || title === "Agreement KPI Analysis" || title === "Claims Analysis" || title === "Correlation"

    const isAutoDeckReportPage = location.pathname === "/autodeck-report";

    // Condition to hide Centralized User Access Management button
    const hideCentralizedUserAccessManagement = isCentralizedDataMappingPage && isDataMappingAcrossStudies;

    const hideAuditingVariablesDocument = isCentralizedDataMappingPage && isDataMappingAcrossStudies;

    const isDeodorants = process.env?.REACT_APP_DEODORANTS?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isOralCare = process.env?.REACT_APP_ORAL_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCare = process.env?.REACT_APP_SKIN_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isUnileverFragranceHouse = process.env?.REACT_APP_UNILEVER_FRAGRANCE_HOUSE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    // Disable the Excel Export button on the Fragrance Driver page, only for Hair Care.
    const disableExcelExportOnFragranceDriver = isFragranceDriverPage && isHairCare;    
    const isHomeUseTest = studyData[0]?.study_type__title === "Home Use Test";
    
    useEffect(() => {
        if (window.location.pathname !== "/studies" && window.location.pathname !== "/studies/" && window.location.pathname !== "/data-seeding" && window.location.pathname !== "/data-seeding/" && window.location.pathname !== "/driver-analysis/" && window.location.pathname !== "/driver-analysis") {
            setIsExcelDownloadable(true);
        }
    }, []);

    useEffect(() => {
        if (checkedProduct.length !== 0) {
            setDisableMoveIcon(false);
        } else {
            setDisableMoveIcon(true);
        }
    }, [checkedProduct]);

    function handleListKeyDown(event) {
        if (event.key === "Tab") {
            event.preventDefault();
            setOpen(false);
        }
    }
    const handleClose = (event) => {
        dispatch(loadSelectedProductState([]));
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    // Helper to format product names with underscores (e.g. "Rexona Powder Dry" -> "Rexona_Powder_Dry")
    const formatProductCode = (name) => name?.split(" ")?.filter(Boolean)?.join("_") || "";

    const handleRespondentDialogueOpen = () => {
        const isTextThemePage = location.pathname === "/text-theme-analysis" || title.toLowerCase() === "text theme analysis" || title.toLowerCase() === "theme text analysis";
        const activeSelections = textThemeSelections?.filter((item) => item.isSelected) || [];

        // Check active filter SPECIFIC to the current page type
        const hasTextThemeFilter = textThemeAppliedConsumerFilters && textThemeAppliedConsumerFilters.length > 0;
        const hasActiveFilterOnPage = isTextThemePage
            ? hasTextThemeFilter
            : (filterSelected || correlationFilterSelected);

        // If on Text Theme Analysis page with checked boxes, prepare product list
        if (isTextThemePage && activeSelections.length > 0) {
            const productMap = {};
            activeSelections.forEach((sel) => {
                const productName = formatProductCode(sel.productCodeTitle);
                const coreDataId = sel.coreDataId.toString();
                productMap[`${productName}__${coreDataId}`] = { productName, coreDataId };
            });
            dispatch(loadProductListState(Object.values(productMap)));
        } else if (isAutoDeckReportPage && selectedProduct) {
            const productMap = {};
            const coreDataId = studyData?.[0]?.id.toString();

            selectedProduct.forEach((sel) => {
                const productName = formatProductCode(sel);

                productMap[`${productName}__${coreDataId}`] = { productName, coreDataId };
            });
            dispatch(loadProductListState(Object.values(productMap)));
        } else {
            // Default: reset product list to show all products
            dispatch(loadProductListState([]));
        }

        // 1. If NO active filter for the current page -> Go directly to /respondent-module
        if (!hasActiveFilterOnPage) {
            navigate("/respondent-module", {
                state: { from: location.pathname },
            });
        } else {
            // 2. If active filter exists for the current page -> SHOW DIALOG BOX
            setRespondentDialogueOpen(!respondentDialogueOpen);
        }
    };

    const handleRespondentDialogueClose = () => {
        setDisableMoveIcon(true);
        setCheckedProduct("");
        setRespondentDialogueOpen(!respondentDialogueOpen);
    };

    // Check if the Text Theme page (TTA) has any filters saved for this specific product
    const hasTTAFilterForProduct = (productCode, coreDataId) => {
        // If there are no TTA filters at all, return false
        if (!textThemeAppliedConsumerFilters || textThemeAppliedConsumerFilters.length === 0) return false;

        const NON_FILTER_KEYS = new Set(["product_code", "core_data_model_id", "backend_variable"]);
        return textThemeAppliedConsumerFilters.some((item) => {
            const itemProductCode = formatProductCode(item.product_code || "");
            const itemCoreDataId = String(item.core_data_model_id || "");

            // Skip if this isn't the product we are currently looking for
            if (itemProductCode !== productCode || itemCoreDataId !== String(coreDataId)) return false;

            // Check if there are actual filter keys applied (ignoring metadata keys)
            return Object.keys(item).some((key) => !NON_FILTER_KEYS.has(key));
        });
    };

    const renderProducts = () => {
        const isTextThemePage = location.pathname === "/text-theme-analysis" || title.toLowerCase() === "text theme analysis" || title.toLowerCase() === "theme text analysis";
        const activeSelections = textThemeSelections?.filter((item) => item.isSelected) || [];

        let products = studyData.map((study) => {
            let coreDataId = study.id;
            let __unileverProducts = study.products?.map((product) => {
                const productCode = formatProductCode(product);

                // On Text Theme Analysis page, filter dialog to ONLY show selected products
                if (isTextThemePage && activeSelections.length > 0) {
                    const isSelected = activeSelections.some(
                        (sel) => formatProductCode(sel.productCodeTitle) === productCode && sel.coreDataId.toString() === coreDataId.toString()
                    );
                    if (!isSelected) return null;
                }

                const value = product + "," + coreDataId + ",0";
                const proTitle = `${product}__${coreDataId}`;
                const proTestCode = productsTestCodeMapData[proTitle];
                const pathName = window.location.pathname;

                // Decide where to look for filters to show the asterisk (*):
                // If on Text Theme page -> Look in the TTA specific filters.
                // If on any other page -> Look in the global 'consumerFilterStoreData'.
                const hasFilter = isTextThemePage
                    ? hasTTAFilterForProduct(productCode, coreDataId)
                    : (() => { const f = consumerFilterPayload(pathName === "/correlation" ? consumerFilterStoreDataForCorrelation : consumerFilterStoreData, productCode, coreDataId); return f && Object.keys(f).length > 0; })();
                return (
                    <FormControlLabel
                        sx={{
                            "& .MuiTypography-root": {
                                fontSize: 12,
                                color: "#495057",
                                padding: 0,
                            },
                            borderRadius: "5px",
                            margin: "3px 0 3px 10px",
                            padding: "0px",
                            color: checkedProduct.includes(value) ? theme.palette.primary.main : theme.palette.text.primary,
                            background: checkedProduct.includes(value) ? "linear-gradient(270deg, rgb(0 103 239 / 0%) 0%, rgb(0 56 139 / 9%) 78%)" : "none",
                        }}
                        value={value}
                        key={value}
                        control={
                            <Checkbox
                                sx={{
                                    color: "#969696",
                                    "& .MuiSvgIcon-root": {
                                        fontSize: 16,
                                    },
                                    "& Mui-checked .MuiSvgIcon-root": {
                                        fontSize: 16,
                                        color: "#1976d2",
                                    },
                                    padding: "6px",
                                }}
                                color="primary"
                                checked={checkedProduct.includes(value)}
                                onChange={handleInputChange}
                                value={value}
                            />
                        }
                        label={
                            product.includes(proTestCode) ? (
                                <span>
                                    {product.split("/")[0]} / {isOralCare && <span style={{ color: "#6f42c1" }}>{proTestCode}</span>}
                                    {isOralCare && " / "}
                                    {study.study_reference__title}
                                    {hasFilter ? <span style={{ fontWeight: "bold", fontSize: "18px" }}>*</span> : null}
                                </span>
                            ) : (
                                <span>
                                    {product} / {isOralCare && <span style={{ color: "#6f42c1" }}>{proTestCode}</span>}
                                    {isOralCare && " / "}
                                    {study.study_reference__title}
                                    {hasFilter ? <span style={{ fontWeight: "bold", fontSize: "14px" }}>*</span> : null}
                                </span>
                            )
                        }
                    />
                );
            });
            let __competitorProducts = study.competitor_products?.map((product) => {
                const productCode = formatProductCode(product);

                // On Text Theme Analysis page, filter dialog to ONLY show selected products
                if (isTextThemePage && activeSelections.length > 0) {
                    const isSelected = activeSelections.some(
                        (sel) => formatProductCode(sel.productCodeTitle) === productCode && sel.coreDataId.toString() === coreDataId.toString()
                    );
                    if (!isSelected) return null;
                }

                const value = product + "," + coreDataId + ",1";
                const proTitle = `${product}__${coreDataId}`;
                const proTestCode = productsTestCodeMapData[proTitle];
                const pathName = window.location.pathname;
                // On TTA page: use TTA card-level filters for asterisk; on other pages: use global consumer filter store
                const hasFilter = isTextThemePage
                    ? hasTTAFilterForProduct(productCode, coreDataId)
                    : (() => { const f = consumerFilterPayload(pathName === "/correlation" ? consumerFilterStoreDataForCorrelation : consumerFilterStoreData, productCode, coreDataId); return f && Object.keys(f).length > 0; })();
                return (
                    <FormControlLabel
                        sx={{
                            "& .MuiTypography-root": {
                                fontSize: 12,
                                color: "#495057",
                                padding: 0,
                            },
                            borderRadius: "5px",
                            margin: "3px 0 3px 10px",
                            padding: "0px",
                            color: checkedProduct.includes(value) ? theme.palette.primary.main : theme.palette.text.primary,
                            background: checkedProduct.includes(value) ? "linear-gradient(270deg, rgb(0 103 239 / 0%) 0%, rgb(0 56 139 / 9%) 78%)" : "none",
                        }}
                        value={value}
                        key={value}
                        control={
                            <Checkbox
                                sx={{
                                    color: "#969696",
                                    "& .MuiSvgIcon-root": {
                                        fontSize: 16,
                                    },
                                    "& Mui-checked .MuiSvgIcon-root": {
                                        fontSize: 16,
                                        color: "#1976d2",
                                    },
                                    padding: "6px",
                                }}
                                color="primary"
                                checked={checkedProduct.includes(value)}
                                onChange={handleInputChange}
                                value={value}
                            />
                        }
                        label={
                            product.includes(proTestCode) ? (
                                <span>
                                    {product.split("/")[0]} / {isOralCare && <span style={{ color: "#6f42c1" }}>{proTestCode}</span>}
                                    {isOralCare && " / "}
                                    {study.study_reference__title}
                                    {hasFilter ? <span style={{ fontWeight: "bold", fontSize: "14px" }}>*</span> : null}
                                </span>
                            ) : (
                                <span>
                                    {product} / {isOralCare && <span style={{ color: "#6f42c1" }}>{proTestCode}</span>}
                                    {isOralCare && " / "}
                                    {study.study_reference__title}
                                    {hasFilter ? <span style={{ fontWeight: "bold", fontSize: "14px" }}>*</span> : null}
                                </span>
                            )
                        }
                    />
                );
            });
            let combinedProducts = [];
            combinedProducts.push(__unileverProducts, __competitorProducts);
            return combinedProducts;
        });
        return (
            <div
                className=""
                style={{
                    display: "flex",
                    flexFlow: "column",
                }}
            >
                <FormControl sx={{ width: "100%" }}>
                    <FormLabel
                        id="demo-row-radio-buttons-group-label"
                        className="input-label-dialog"
                    >
                        Select the product(s) to view the respondent profiles for:
                    </FormLabel>
                    <div
                        style={{
                            margin: "3px,0px,3px,1px",
                        }}
                    >
                        <FormControlLabel
                            sx={{
                                "& .MuiTypography-root": {
                                    fontSize: 12,
                                    color: "#495057",
                                    padding: 0,
                                },
                                borderRadius: "5px",
                                width: "100%",
                                margin: "3px 0px",
                                padding: "0px",
                                color: allSelected ? theme.palette.primary.main : theme.palette.text.primary,
                                background: allSelected ? "linear-gradient(270deg, rgb(0 103 239 / 0%) 0%, rgb(0 56 139 / 9%) 78%)" : "none",
                            }}
                            control={
                                <Checkbox
                                    sx={{
                                        color: "#969696",
                                        "& .MuiSvgIcon-root": {
                                            fontSize: 16,
                                        },
                                        padding: "6px",
                                    }}
                                    color="primary"
                                    checked={allSelected}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            setCheckedProduct(allProductValues);
                                        } else {
                                            setCheckedProduct([]);
                                        }
                                    }}
                                />
                            }
                            label={"Select All"}
                        />
                    </div>
                    {products.map((_product) => _product)}
                    <FormLabel
                        id="demo-row-radio-buttons-group-label"
                        style={{
                            fontSize: "12px",
                            marginTop: "30px",
                            color: "#424242",
                        }}
                    >
                        <strong>
                            *Note : You have applied filter(s) to one of the products displayed in the interface. Now, select one or more products <br />
                            for which you want to view the sample information.
                        </strong>
                    </FormLabel>
                </FormControl>
            </div>
        );
    };
    // Get all product values (unilever + competitor) from all studies
    const allProductValues = studyData.flatMap((study) => {
        const unileverValues = study.products?.map((product) => `${product},${study.id},0`) || [];
        const competitorValues = study.competitor_products?.map((product) => `${product},${study.id},1`) || [];
        const allProducts = [...unileverValues, ...competitorValues];

        const isTextThemePage = location.pathname === "/text-theme-analysis" || title.toLowerCase() === "text theme analysis" || title.toLowerCase() === "theme text analysis";
        const activeSelections = textThemeSelections?.filter((item) => item.isSelected) || [];

        // On Text Theme Analysis page, filter "Select All" options to only include checked products
        if (isTextThemePage && activeSelections.length > 0) {
            return allProducts.filter((productValue) => {
                const productRawName = productValue.split(",")[0];
                const coreDataId = productValue.split(",")[1];
                const productCode = formatProductCode(productRawName);

                return activeSelections.some(
                    (sel) => formatProductCode(sel.productCodeTitle) === productCode && sel.coreDataId.toString() === coreDataId.toString()
                );
            });
        }

        return allProducts;
    });

    // Check if all products are currently selected
    const allSelected = allProductValues.length > 0 && allProductValues.every((val) => checkedProduct.includes(val));

    const handleInputChange = (e) => {
        let products = [...checkedProduct];
        if (e.target.checked) {
            products.push(e.target.value);
        } else {
            products = products.filter((item) => item !== e.target.value);
        }
        setCheckedProduct(products);
    };

    const handleSubmit = () => {
        let filterQueryString = "";
        let url = "/respondent-module";
        let componentName = null;
        let pageName = null;
        let productList = [];
        let cfFlag = false;

        if (window.location.href.split("/").indexOf("overall-kpi") !== -1) {
            componentName = "overallKpiDataState";
            pageName = "overallKpiAnalysis";
        } else if (window.location.href.split("/").indexOf("secondary-attribute") !== -1) {
            componentName = "overallKpiDataState";
            pageName = "secondaryAttributeAnalysis";
        } else if (window.location.href.split("/").indexOf("agreement-analysis") !== -1) {
            componentName = "agreementKpiDataState";
            pageName = "agreementKpiAnalysis";
        } else if (window.location.href.split("/").indexOf("claims-analysis") !== -1) {
            componentName = "claimsDataState";
            pageName = "claimsAnalysis";
        } else if (window.location.href.split("/").indexOf("just-right-analysis") !== -1) {
            componentName = "justRightDataState";
            pageName = "justRightAnalysis";
        }

        // Build a per-product filter map from TTA card-level filters (only on Text Theme Analysis page)
        const isTextThemePage = location.pathname === "/text-theme-analysis" || title.toLowerCase() === "text theme analysis" || title.toLowerCase() === "theme text analysis";
        const textThemeFilters = {};
        if (isTextThemePage) {
            (textThemeAppliedConsumerFilters || []).forEach((item) => {
                const key = `${item.product_code.split(" ").join("_")}__${item.core_data_model_id}`;
                const filterPayload = Object.fromEntries(
                    Object.entries(item).filter(([k]) => !["product_code", "core_data_model_id", "backend_variable"].includes(k))
                );
                if (Object.keys(filterPayload).length) {
                    textThemeFilters[key] = { ...(textThemeFilters[key] || {}), ...filterPayload };
                }
            });
        }

        checkedProduct.forEach((ele) => {
            const productCode = ele.split(",")[0].split(" ").join("_");
            const coreDataId = ele.split(",")[1];
            const isCompetitor = ele.split(",")[2] == 1;
            productList.push({ productName: productCode, coreDataId: coreDataId, isCompetitor: isCompetitor });
            filterQueryString = consumerFilterPayload(consumerFilterStoreData, productCode, coreDataId, "perProductRespondent");
            if (filterQueryString !== "") {
                cfFlag = true;
            }
        });

        dispatch(loadProductListState(productList));
        url += `?component=${componentName}&page=${pageName}`;
        if (cfFlag) {
            url += `&return_type=consumer_filter`;
        }
        navigate(url, {
            state: { from: location.pathname, textThemeFilters },
        });
    };

    useEffect(() => {
        if (title.toLowerCase() === "match net" || title.toLowerCase() === "matchnet lookup table" || title.toLowerCase() === "matchnet - cross study comparison") {
            setDisableStatus(selectedProducts.length === 0);
        } else if (isAutoDeckReportPage && selectedTabForAutoDeck === "generation") {
            setDisableStatus(true);
        } else {
            setDisableStatus(studyData.length === 0 || disableProductInfoAndExportStudiesBtns);
        }
    }, [studyData, selectedProducts, title, disableProductInfoAndExportStudiesBtns, isAutoDeckReportPage, selectedTabForAutoDeck]);

    useEffect(() => {
        if (isMatchNetPage) {
            setHideExcelExport(true);
        } else {
            setHideExcelExport(isDataControlPanelPage && !isClaimsMappingPage && !isRespondentSettingsPage);
        }
    }, [isMatchNetPage, isDataControlPanelPage, isClaimsMappingPage, isRespondentSettingsPage]);

    return (
        <>
            <Grid
                className="header-container background-color-blue color-white p-0"
                container
                spacing={2}
            >
                <Grid
                    item
                    xs={3}
                >
                    <div className="header-logo-container vertical-center py-2 ms-2">
                        <span className="ms-3">
                            <img
                                className="vertical-center brand-logo--header"
                                src={uniLogoWithName}
                                alt="uni"
                                style={{ height: "40px", width: "auto" }}
                            />
                        </span>
                    </div>
                </Grid>
                <Grid
                    item
                    xs={6}
                >
                    <div className="vertical-center ">
                        <span
                            className=" text-upper-case text-center d-block text-xl l-spacing-3 text-bold-7"
                            style={{
                                textShadow: "0 0 10px #FFFFFF, 11px -1px 12px rgba(255,71,217,0)",
                            }}
                        >
                            {title}
                            {titleSuffix && <span className="header-title-suffix">{titleSuffix}</span>}
                        </span>
                        {/* <span 
                            className=" text-upper-case text-center text-xs l-spacing-3 text-bold-4"
                            style={{
                                textShadow: "0 0 10px #FFFFFF, 11px -1px 12px rgba(255,71,217,0)",
                            }}
                        >
                            {selectedStudyType !== "" ? selectedStudyType === "home_use_test" ? "(Home Use Test Compatibility Context)" :  "(Fragrance Testing Compatibility Context)" : ""}
                        </span> */}
                    </div>
                </Grid>
                <Grid
                    item
                    xs={3}
                >
                    <div className="header-icons-container vertical-center me-3">
                        {userAdmin && title === "Home" && (
                            <span>
                                <Link to="/user-access-management">
                                    <AccountCircleIcon
                                        // isStudySelected
                                        className="color-white"
                                        sx={{
                                            fontSize: "1.75rem",
                                            border: "4px solid #578FE6",
                                            borderRadius: "50%",
                                            backgroundColor: "#578FE6",
                                        }}
                                    />
                                </Link>
                            </span>
                        )}
                        {title !== "Home" && (
                            <span>
                                <Link to="/">
                                    <HomeIcon
                                        className="color-white"
                                        sx={{
                                            fontSize: "1.75rem",
                                            border: "4px solid #578FE6",
                                            borderRadius: "50%",
                                            backgroundColor: "#578FE6",
                                        }}
                                    />
                                </Link>
                            </span>
                        )}
                        {title !== "Home" && title !== "User Access Management" && (
                            <Tooltip
                                placement="top"
                                title="Respondent Profile"
                                color="#343a40"
                            >
                                <span className="ms-4">
                                    {
                                        title.toLowerCase() === "overall kpi analysis" ||
                                            title.toLowerCase() === "agreement kpi analysis" ||
                                            title.toLowerCase() === "claims analysis" ||
                                            title.toLowerCase() === "correlation" ||
                                            title.toLowerCase() === "fragrance metrics analysis" ||
                                            title.toLowerCase() === "preference analysis" ||
                                            title.toLowerCase() === "product preference analysis" ||
                                            title.toLowerCase() === "fragrance association" ||
                                            title.toLowerCase() === "autodeck report" ||
                                            title.toLowerCase() === "just right analysis" ||
                                            title.toLowerCase() === "jar analysis" ||
                                            (title.toLowerCase() === "text theme analysis" || title.toLowerCase() === "theme text analysis") ? (
                                            <IconButton
                                                onClick={handleRespondentDialogueOpen}
                                                disabled={isAutoDeckReportPage && selectedTabForAutoDeck === "generation"}
                                            >
                                                <AccountCircleIcon
                                                    // isStudySelected
                                                    className={isStudySelected ? "color-white" : "disabled"}
                                                    sx={{
                                                        fontSize: "1.75rem",
                                                        border: "4px solid #578FE6",
                                                        borderRadius: "50%",
                                                        backgroundColor: "#578FE6",
                                                    }}
                                                />
                                            </IconButton>
                                        ) : (
                                            <Link
                                                className={isStudySelected ? "" : "disabled"}
                                                to="/respondent-module"
                                            >
                                                <AccountCircleIcon
                                                    // isStudySelected
                                                    className={isStudySelected ? "color-white" : "disabled"}
                                                    sx={{
                                                        fontSize: "1.75rem",
                                                        border: "4px solid #578FE6",
                                                        borderRadius: "50%",
                                                        backgroundColor: "#578FE6",
                                                    }}
                                                />
                                            </Link>
                                        )}

                                </span>
                            </Tooltip>
                        )}
                        {title !== "Home" && title !== "User Access Management" && (
                            <span className="ms-4 me-2">
                                <SettingsIcon
                                    ref={anchorRef}
                                    aria-controls={open ? "menu-list-grow" : undefined}
                                    aria-haspopup="true"
                                    onClick={handleToggle}
                                    sx={{
                                        fontSize: "1.75rem",
                                        border: "4px solid #578FE6",
                                        borderRadius: "50%",
                                        backgroundColor: "#578FE6",
                                    }}
                                />
                                <Popper
                                    className="me-3"
                                    open={open}
                                    anchorEl={anchorRef.current}
                                    role={undefined}
                                    transition
                                    disablePortal
                                >
                                    {({ TransitionProps, placement }) => (
                                        <Grow
                                            {...TransitionProps}
                                            style={{
                                                transformOrigin: placement === "bottom" ? "center top" : "center bottom",
                                            }}
                                        >
                                            <Paper>
                                                <ClickAwayListener onClickAway={handleClose}>
                                                    <MenuList
                                                        autoFocusItem={open}
                                                        id="menu-list-grow"
                                                        onKeyDown={handleListKeyDown}
                                                        dense={true}
                                                        className="horizontal-menu mt-2"
                                                        style={studyData.length == 0 ? { ...disableMenuItem } : { cursor: "pointer" }}
                                                    >
                                                        <MenuItem
                                                            className="menu-list"
                                                            disabled={disableStatus}
                                                            onClick={(e) => {
                                                                if (disableStatus) {
                                                                    // Check if there are no studies selected
                                                                    e.preventDefault(); // Prevent the default action (i.e., opening the link)
                                                                    return; // Exit the function early if no studies are selected
                                                                }
                                                                let downloadUrl = null;
                                                                if (selectedProducts.length > 0) {
                                                                    const ids = [...new Set(selectedProducts.map((product) => product.core_data_id))];
                                                                    const coreDataModelIds = ids.join(",");
                                                                    downloadUrl = `${process.env.REACT_APP_SERVER_PATH}/products/export-product-info/?core_data_ids=${coreDataModelIds}`;
                                                                } else {
                                                                    if (isDeodorants) {
                                                                        downloadUrl = `${process.env.REACT_APP_SERVER_PATH}/products/export-product-info/?core_data_ids=${coreDataIds}`;
                                                                    } else if (isOralCare) {
                                                                        downloadUrl = `${process.env.REACT_APP_SERVER_PATH}/oral-care-products/export-oral-care-product-info/?core_data_ids=${coreDataIds}`;
                                                                    } else if (isSkinCare) {
                                                                        downloadUrl = `${process.env.REACT_APP_SERVER_PATH}/skin-care-products/export-skin-care-product-info/?core_data_ids=${coreDataIds}`;
                                                                    } else if (isHairCare) {
                                                                        downloadUrl = `${process.env.REACT_APP_SERVER_PATH}/hair-care-products/export-hair-care-product-info/?core_data_ids=${coreDataIds}`;
                                                                    } else if (isUnileverFragranceHouse) {
                                                                        downloadUrl = `${process.env.REACT_APP_SERVER_PATH}/unilever-fragrance-house-products/export-unilever-fragrance-house-product-info/?core_data_ids=${coreDataIds}`;
                                                                    } else {
                                                                        downloadUrl = `${process.env.REACT_APP_SERVER_PATH}/skin-cleansing-products/export-skin-cleansing-product-info/?core_data_ids=${coreDataIds}`;
                                                                    }
                                                                }
                                                                window.open(downloadUrl); // Open the URL in a new tab
                                                            }}
                                                            style={disableStatus ? { padding: "0px 6px", ...disableMenuItem } : { padding: "0px 6px" }}
                                                        >
                                                            <ListItemIcon>
                                                                <div style={{ margin: "0px auto", backgroundColor: "#F2F1F1", borderRadius: "50%" }}>
                                                                    <img
                                                                        alt="productDownload"
                                                                        src={productDownlodIcon}
                                                                        style={{ color: "#005eef", padding: "6px", width: "23px" }}
                                                                    />
                                                                </div>
                                                            </ListItemIcon>
                                                            <div
                                                                style={{
                                                                    fontSize: 10,
                                                                    textAlign: "center",
                                                                    marginTop: 6,
                                                                }}
                                                            >
                                                                Download <br /> Product Information
                                                            </div>
                                                        </MenuItem>

                                                        {/* Export Studies  - REMOVED for Data Control Panel pages */}
                                                        {!hideExportStudies && (
                                                            <MenuItem
                                                                className="menu-list"
                                                                disabled={listedStudiesData.length === 0 || disableProductInfoAndExportStudiesBtns}
                                                                onClick={(e) => {
                                                                    if (listedStudiesData.length === 0 || disableProductInfoAndExportStudiesBtns) {
                                                                        // Check if there are no studies selected
                                                                        e.preventDefault(); // Prevent the default action (i.e., opening the link)
                                                                        return; // Exit the function early if no studies are selected
                                                                    }
                                                                    const downloadUrl = `${process.env.REACT_APP_SERVER_PATH}/core-data-models/study-page-excel/?id=${coreDataIdsForExportStudies}`;
                                                                    window.open(downloadUrl); // Open the URL in a new tab
                                                                }}
                                                                style={listedStudiesData.length === 0 || disableProductInfoAndExportStudiesBtns ? { padding: "0px 6px", ...disableMenuItem } : { padding: "0px 6px" }}
                                                            >
                                                                <ListItemIcon>
                                                                    <FileDownloadIcon
                                                                        style={{
                                                                            color: "#005eef",
                                                                            fontSize: 22,
                                                                            margin: "0px auto",
                                                                            border: "4px solid #F2F1F1",
                                                                            borderRadius: "50%",
                                                                            backgroundColor: "#F2F1F1",
                                                                        }}
                                                                    />
                                                                </ListItemIcon>
                                                                <div
                                                                    style={{
                                                                        fontSize: 10,
                                                                        textAlign: "center",
                                                                        marginTop: 6,
                                                                    }}
                                                                >
                                                                    Export
                                                                    <br /> Studies
                                                                </div>
                                                            </MenuItem>
                                                        )}

                                                        {/* Excel Export Menu Item - REMOVED for Data Control Panel pages except Claims Mapping */}
                                                        {isExcelDownloadable && !hideExcelExport && title !== "AutoDeck Report" && (
                                                            <MenuItem
                                                                className="menu-list"
                                                                onClick={(e) => {
                                                                    if (disableExcelExportOnRespondentSettings || disableExcelExportOnFragranceDriver) return;
                                                                    setOpenDownloadDialog(true);
                                                                    handleClose(e);
                                                                }}
                                                                style={{ padding: "0px 6px" }}
                                                                disabled={disableExcelExportOnRespondentSettings || disableExcelExportOnFragranceDriver}
                                                            >
                                                                <ListItemIcon>
                                                                    <div style={{ margin: "0px auto", backgroundColor: "#F2F1F1", borderRadius: "50%" }}>
                                                                        <img
                                                                            alt="excelExport"
                                                                            src={excelIcon}
                                                                            style={{ color: "#005eef", padding: "6px", width: "23px" }}
                                                                        />
                                                                    </div>
                                                                </ListItemIcon>
                                                                <div
                                                                    style={{
                                                                        fontSize: 10,
                                                                        textAlign: "center",
                                                                        marginTop: 6,
                                                                    }}
                                                                >
                                                                    Excel <br /> Export
                                                                </div>
                                                            </MenuItem>
                                                        )}

                                                        {isDeodorants && showAutoDeckReport && role && role.toLowerCase() === "admin" && (
                                                            <Tooltip
                                                                title={studyData.length > 1 ? "AutoDeck Report can only be activated for single study selection" : ""}
                                                                // placement="top-start"
                                                                componentsProps={{
                                                                    tooltip: {
                                                                        sx: {
                                                                            bgcolor: "rgb(51, 94, 234,0.1)",
                                                                            color: "#000",
                                                                            maxWidth: 200,
                                                                            boxShadow: 2,
                                                                        },
                                                                    },
                                                                    arrow: {
                                                                        sx: {
                                                                            color: "rgb(51, 94, 234,0.1)",
                                                                        },
                                                                    },
                                                                }}
                                                            >
                                                                <span>
                                                                    <MenuItem
                                                                        className="menu-list"
                                                                        onClick={handleClose}
                                                                        style={{ padding: "0px 6px 0px 14px" }}
                                                                        disabled={studyData.length !== 1 || !isHomeUseTest}
                                                                    >
                                                                        <Link to="/autodeck-report">
                                                                            <ListItemIcon>
                                                                                <div style={{ margin: "0px 12px", backgroundColor: "#F2F1F1", borderRadius: "50%" }}>
                                                                                    <img
                                                                                        alt="excelExport"
                                                                                        src={autoDeckReportPng}
                                                                                        style={{ color: "#005eef", padding: "6px", width: "23px" }}
                                                                                    />
                                                                                </div>
                                                                            </ListItemIcon>
                                                                            <div
                                                                                style={{
                                                                                    fontSize: 10,
                                                                                    textAlign: "center",
                                                                                    marginTop: 6,
                                                                                }}
                                                                            >
                                                                                AutoDeck
                                                                                <br />
                                                                                Report
                                                                            </div>
                                                                        </Link>
                                                                    </MenuItem>
                                                                </span>
                                                            </Tooltip>
                                                        )}

                                                        {hideCentralizedUserAccessManagement && (
                                                            <MenuItem
                                                                className="menu-list"
                                                                onClick={() => setOpenDownloadDialog(true)}
                                                                style={{ padding: "0px 6px" }}
                                                                disabled={!centralizedDataMappingSelectedStudyType || !centralizedDataMappingSelectedStudyTypeMethod}
                                                            >
                                                                <ListItemIcon>
                                                                    <div style={{ margin: "0px auto", backgroundColor: "#F2F1F1", borderRadius: "50%" }}>
                                                                        <img
                                                                            alt="excelExport"
                                                                            src={excelIcon}
                                                                            style={{ color: "#005eef", padding: "6px", width: "23px" }}
                                                                        />
                                                                    </div>
                                                                </ListItemIcon>
                                                                <div
                                                                    style={{
                                                                        fontSize: 10,
                                                                        textAlign: "center",
                                                                        marginTop: 2,
                                                                    }}
                                                                >
                                                                    Centralized User
                                                                    <br /> Access Management
                                                                </div>
                                                            </MenuItem>
                                                        )}
                                                        {hideAuditingVariablesDocument && (
                                                            <MenuItem
                                                                className="menu-list"
                                                                onClick={() => {
                                                                    setOpenAuditingVariablesDocumentDialog(true);
                                                                }}
                                                                style={{ padding: "0px 6px" }}
                                                            >
                                                                <ListItemIcon>
                                                                    <div style={{ margin: "0px auto", backgroundColor: "#F2F1F1", borderRadius: "50%" }}>
                                                                        <img
                                                                            alt="excelExport"
                                                                            src={auditingVariableDocumentsIcon}
                                                                            style={{ color: "#005eef", padding: "6px", width: "23px" }}
                                                                        />
                                                                    </div>
                                                                </ListItemIcon>
                                                                <div
                                                                    style={{
                                                                        fontSize: 10,
                                                                        textAlign: "center",
                                                                        marginTop: 2,
                                                                    }}
                                                                >
                                                                    Auditing Variables
                                                                    <br /> Document
                                                                </div>
                                                            </MenuItem>
                                                        )}
                                                        {/* Menu Item for Data Control Panel*/}
                                                        {role && role.toLowerCase() === "admin" && (
                                                            <MenuItem
                                                                className="menu-list"
                                                                onClick={handleClose}
                                                                style={{ padding: "0px 6px" }}
                                                            >
                                                                <Link to="/data-control-panel">
                                                                    <ListItemIcon>
                                                                        <UploadFileIcon
                                                                            style={{
                                                                                color: "#005eef",
                                                                                fontSize: 22,
                                                                                margin: "0px 0px 0px 20px",
                                                                                border: "4px solid #F2F1F1",
                                                                                borderRadius: "50%",
                                                                                backgroundColor: "#F2F1F1",
                                                                            }}
                                                                        />
                                                                    </ListItemIcon>
                                                                    <div
                                                                        style={{
                                                                            fontSize: 10,
                                                                            textAlign: "center",
                                                                            marginTop: 0,
                                                                        }}
                                                                    >
                                                                        Data
                                                                        <br />
                                                                        Control Panel
                                                                    </div>
                                                                </Link>
                                                            </MenuItem>
                                                        )}

                                                        {role && role.toLowerCase() === "admin" && (
                                                            <MenuItem
                                                                className="menu-list"
                                                                onClick={handleClose}
                                                                style={{
                                                                    padding: "0px 6px",
                                                                }}
                                                            >
                                                                <Link to="/user-management">
                                                                    <ListItemIcon>
                                                                        <PersonAddIcon
                                                                            style={{
                                                                                color: "#005eef",
                                                                                fontSize: 22,
                                                                                margin: "0px 0px 0px 24px",
                                                                                border: "4px solid #F2F1F1",
                                                                                borderRadius: "50%",
                                                                                backgroundColor: "#F2F1F1",
                                                                            }}
                                                                        />
                                                                    </ListItemIcon>
                                                                    <div
                                                                        style={{
                                                                            fontSize: 10,
                                                                            textAlign: "center",
                                                                            marginTop: 0,
                                                                        }}
                                                                    >
                                                                        User <br /> Management
                                                                    </div>
                                                                </Link>
                                                            </MenuItem>
                                                        )}
                                                        <MenuItem
                                                            className="menu-list"
                                                            onClick={handleClose}
                                                            style={{ padding: "0px 6px" }}
                                                            disabled={true}
                                                        >
                                                            <Link to="/">
                                                                <ListItemIcon>
                                                                    <HelpIcon
                                                                        style={{
                                                                            color: "#005eef",
                                                                            fontSize: 22,
                                                                            margin: "0px auto",
                                                                            border: "4px solid #F2F1F1",
                                                                            borderRadius: "50%",
                                                                            backgroundColor: "#F2F1F1",
                                                                        }}
                                                                    />
                                                                </ListItemIcon>
                                                                <div
                                                                    style={{
                                                                        fontSize: 10,
                                                                        textAlign: "center",
                                                                        marginTop: 2,
                                                                    }}
                                                                >
                                                                    Help <br /> Docs
                                                                </div>
                                                            </Link>
                                                        </MenuItem>
                                                    </MenuList>
                                                </ClickAwayListener>
                                            </Paper>
                                        </Grow>
                                    )}
                                </Popper>
                            </span>
                        )}
                    </div>
                </Grid>
            </Grid>
            {openDownloadDialog && (
                <DownloadDialog
                    open={openDownloadDialog}
                    setOpen={setOpenDownloadDialog}
                />
            )}
            {openAuditingVariablesDocumentDialog && (
                <AuditingVariablesDocumentDialog
                    open={openAuditingVariablesDocumentDialog}
                    setOpen={setOpenAuditingVariablesDocumentDialog}
                />
            )}
            {respondentDialogueOpen && (
                <Dialog
                    open={respondentDialogueOpen}
                    onClose={handleRespondentDialogueClose}
                    // aria-labelledby="alert-dialog-title"
                    // aria-describedby="alert-dialog-description"
                    fullWidth={true}
                    maxWidth="md"
                >
                    <DialogTitle
                        style={{
                            backgroundColor: "rgb(51, 94, 234,0.1)",
                            color: "rgb(51, 94, 234)",
                            fontSize: 15,
                            textAlign: "center",
                            padding: "10px 12px",
                        }}
                        // className="liner-light-blue-background-2"
                        id="alert-dialog-title"
                    >
                        Select Any Product
                        <IconButton
                            aria-label="close"
                            sx={{
                                position: "absolute",
                                right: 8,
                                top: 2,
                                // fontSize: 10,
                                color: "rgb(51, 94, 234) !important",
                            }}
                            onClick={handleRespondentDialogueClose}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <div style={{ minHeight: 200 }}>
                            <div className="mt-3">{renderProducts()}</div>
                        </div>
                    </DialogContent>
                    <div
                        style={{
                            display: "flex",
                            width: "100%",
                            justifyContent: "center",
                        }}
                    >
                        {!disableMoveIcon && (
                            <div
                                style={{
                                    width: "35%",
                                    marginBottom: "-4px",
                                }}
                                className={disableMoveIcon ? "move-button--hidden" : "move-button--visible"}
                            >
                                <div
                                    className="px-2 py-1"
                                    style={{
                                        position: "absolute",
                                        right: 90,
                                        bottom: 0,
                                        cursor: "pointer",
                                        width: 50,
                                        height: 35,
                                        // overflow: "hidden",
                                    }}
                                    onClick={handleSubmit}
                                >
                                    <img
                                        style={{
                                            width: 30,
                                            height: 25,
                                            color: "white",
                                            filter: "brightness(0) invert(1)",
                                        }}
                                        src={forwardPng}
                                        alt={"forward"}
                                    />
                                </div>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 1440 320"
                                >
                                    <path
                                        fill="#005eef"
                                        // fill="#9c27b0"
                                        fillOpacity="1"
                                        d="M0,288L60,288C120,288,240,288,360,250.7C480,213,600,139,720,101.3C840,64,960,64,1080,106.7C1200,149,1320,235,1380,277.3L1440,320L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
                                    ></path>
                                </svg>
                            </div>
                        )}
                    </div>
                </Dialog>
            )}
        </>
    );
}

// Typechecking props for the Header
Header.propTypes = {
    title: PropTypes.string,
    titleSuffix: PropTypes.node,
    isStudySelected: PropTypes.bool,
    // consumerFilter: PropTypes.array,
    // tTestPerformed: PropTypes.bool,
    // confidenceInterval: PropTypes.string,
    // tTestType: PropTypes.string,
    // tTestProducts: PropTypes.string,
    // tTestCoreDataId: PropTypes.number,
    // checkedDataTypeForTest: PropTypes.string,
    // tTestAnalysisType: PropTypes.string,
    // dataMappingAcrossStudies: PropTypes.bool,
};

export default Header;